import { DatePicker } from 'antd';
import dayjs, { Dayjs } from 'dayjs';

type Props = {
	name: string;
	label?: string;
	value: string;
	required: boolean;
	isError: boolean;
	onChange: (value: string) => void;
	placeholder?: string;
	helperText?: string;
	disabled?: boolean;
	picker?: 'date' | 'month' | 'year';
	disabledBeforeDates?: any;
	disabledAfterDates?: any;
	isViewOnly?: boolean;
	disableSunday?: boolean;
	style?: any;
	allowClear?: boolean;
};

const DatePickerField = (props: Props) => {
	const {
		name,
		label,
		value,
		placeholder,
		isError = false,
		required = false,
		onChange,
		disabled = false,
		helperText = 'Date is required',
		picker = 'date',
		disabledBeforeDates,
		disabledAfterDates,
		isViewOnly = false,
		disableSunday = false,
		style,
		allowClear = false,
	} = props;

	const handleChange = (value: Dayjs | null) => {
		onChange(value ? value.toISOString() : '');
	};

	return (
		<div className="input-field" style={{ ...style }}>
			{label && (
				<p
					className="label"
					style={{ marginBottom: `${isViewOnly ? '5px' : ''}` }}
				>
					{label}{' '}
					{required && !isViewOnly && <span className="red">*</span>}
				</p>
			)}
			{isViewOnly ? (
				<p>{dayjs(value).format('DD/MM/YYYY')}</p>
			) : (
				<div>
					<DatePicker
						name={name}
						value={value ? dayjs(value) : null}
						size="large"
						onChange={handleChange}
						format={
							picker === 'year'
								? 'YYYY'
								: picker === 'month'
								? 'MMM, YYYY'
								: 'DD/MM/YYYY'
						}
						disabled={disabled}
						placeholder={placeholder}
						style={{ width: '100%' }}
						status={isError ? 'error' : ''}
						picker={picker}
						disabledDate={(current: Dayjs) => {
							return (
								(disabledBeforeDates &&
									current < dayjs(disabledBeforeDates)) ||
								(disabledAfterDates &&
									current > dayjs(disabledAfterDates)) ||
								(disableSunday && current.day() === 0)
							);
						}}
						allowClear={allowClear}
					/>
					{isError && (
						<p
							className="red"
							style={{
								fontSize: '12px',
								marginLeft: '2px',
							}}
						>
							{helperText}
						</p>
					)}
				</div>
			)}
		</div>
	);
};

export default DatePickerField;
